import { detect } from 'detect-browser'
import { isSupported } from 'twilio-video'

import { JitsiMeet } from '~/modules/Jitsi'

export const browserDetectionHandler = () => {
  const browser = detect()
  if (!browser) return null

  const iosAgents = ['safari', 'crios', 'ios']
  const mobileOs = ['ios', 'android']
  const systemOs = browser.os?.split(' ')[0].toLowerCase()

  const twilio = {
    browsersSupported: [],
    isSupportedBrowser: false,
    isSupportedVersion: true,
  }

  const detectedBrowser = { ...browser }

  if (iosAgents.includes(browser.name)) {
    detectedBrowser.name = 'safari'
    twilio.isSupportedVersion = browser.version >= '12.1'
  }

  switch (systemOs) {
  case 'android':
    twilio.browsersSupported = ['chrome', 'firefox']
    break
  case 'linux':
    twilio.browsersSupported = ['chrome', 'firefox']
    break
  case 'ios':
    twilio.browsersSupported =
        browser.version < '14.3' ? ['safari'] : ['safari', 'chrome']
    break
  case 'macos':
  case 'mac':
    twilio.browsersSupported = [
      'chrome',
      'firefox',
      'safari',
      'edge-chromium',
    ]
    break
  case 'windows':
    twilio.browsersSupported = ['chrome', 'firefox', 'edge-chromium']
    break
  default:
    twilio.browsersSupported = []
  }

  twilio.isSupportedBrowser =
    isSupported &&
    !!twilio.browsersSupported.find(item => item === detectedBrowser.name)

  const jitsi = {
    isSupportedBrowser: JitsiMeet.isWebRtcSupported(),
  }

  return {
    browser: detectedBrowser,
    isMobile: mobileOs.includes(systemOs),
    twilio,
    jitsi,
  }
}
